module.exports = __webpack_public_path__ + "media/images/vp/bg.heart2.red-f7a004104acc6a86a58333c68b895707.png";